import { render, staticRenderFns } from "./DivergentTableLineDesktop.vue?vue&type=template&id=5c211b94&scoped=true"
import script from "./DivergentTableLineDesktop.vue?vue&type=script&lang=js"
export * from "./DivergentTableLineDesktop.vue?vue&type=script&lang=js"
import style0 from "./DivergentTableLineDesktop.vue?vue&type=style&index=0&id=5c211b94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c211b94",
  null
  
)

export default component.exports